<template>
 
    <NavView></NavView>
    <SideBar></SideBar>
    {{this.my}}

    <div class="container-fluid">
        <!-- <h6 class=" font1 font-bold1 colr1 ">Create Customer</h6> -->
        <h6 class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/mrentedvehicles/index"> Manage Rented Vehicles </router-link><span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create VIN </h6>



    
        <div class="card font1 ">
            <div class="card-body font1">

                <Form @submit="saveData()" class=" g-3"  :validation-schema="schema" v-slot="{ errors }" >
                    <div class="row ">
                        
                       

                       

                       
                        <CCol md="3">
                            <CFormLabel  for="inputState">Issue Date</CFormLabel> 
                            <!-- <v-select
                            item-text="name"
                            item-value="themeFile"
                            v-model="theme"
                            :items="themes"
                        ></v-select> -->
                            <Field name="Issue_date" v-model="istockissue.issues_date" type="date"  class="form-control" 
                            rules="required"  />
                             <!-- <Field rules="required" id="inputState" name="group"  /> -->
                            
                             <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                             <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                             </div> -->
                             
                         </CCol>
                       
                         <CCol md="3">
                            <CFormLabel  for="customer">Customer</CFormLabel> 
                            <!-- <v-select  item-text="C_name" :items="mcustomers"  ></v-select> -->
                            
                            
                             <select style="width:100%;"  class="js-example-basic-multiple "  id="customer_list"  v-model="istockissue.id_customer"   >
                             
                               
                                
                               <option  v-for="mcustomer in mcustomers" :key="mcustomer.idCustomer"  :value="mcustomer.idCustomer"  class="font1">{{mcustomer.C_name}}</option> 
                             </select> 
                            
                             <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                             <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                             </div> -->
                         </CCol>
                      
                        <CCol md="3">
                
                            <button type="button" class="btn btn-primary btn11  pt-1 pb-1" data-bs-toggle="modal"  data-bs-target="#exampleModal1">+ New Customer </button>
                             
                   
                            <div class="modal fade" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                              <div class="modal-dialog modal-dialog-scrollable modal-xl">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">New customer</h5>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                  </div>
                                  <div class="modal-body">


                                    <div  class=" g-3"  >
                                      <div class="row ">
                                          <CCol md="3">
                                             <CFormLabel  for="inputState">Customer Group</CFormLabel> 
                                            
                                              <!-- <Field rules="required" id="inputState" name="group"  /> -->
                                              <CFormSelect class=" "  name="name3" id="notificationPreference" v-model="customer.customer_type"   >
                                                  
                                                  <option class="font1">choose...</option>
                                                 
                                                  <option class="font1">Individual</option>
                                                  <option class="font1">Corporate</option>
                                                  <option class="font1">Large Corporate</option>
                                                  <option class="font1">Frequent User</option>
                                                  <option class="font1">Ride Hailing</option>
                                              </CFormSelect>
                                              <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                                              <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                                              </div> -->
                                          </CCol>
                                          <CCol md="3">
                                              <CFormLabel for="inputName4"> Sales Executive </CFormLabel>
                                              <CFormInput v-model="customer.salesexecutive" type="text" id="inputName4" />
                                      
                  
                                          </CCol>
                  
                                      </div><br>
                  
                                      <div class="row">
                  
                                          <CCol md="3">
                                              <CFormLabel for="inputName4">Customer Name</CFormLabel>
                                               <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                                              
                  
                                               <Field name="name" class="form-control"
                                              v-model="customer.C_name" />
                                            
                                              
                                              
                                          </CCol>
                  
                                          <CCol md="3">
                                              <CFormLabel for="inputName4">First Name</CFormLabel>
                                              <CFormInput v-model="customer.C_firstname" type="text" id="inputName4"  />
                                              
                  
                                          </CCol>
                                          <CCol md="3">
                                              <CFormLabel for="inputName4">Last Name</CFormLabel>
                                              <CFormInput v-model="customer.C_lastname" type="text" id="inputName4"  />
                                             
                  
                                          </CCol>
                                          <CCol md="3">
                                              <CFormLabel for="inputName4">NRIC</CFormLabel>
                                               <CFormInput   v-model="customer.nic_no"  type="number" id="inputName4"/> 
                                              
                  
                                                <!-- <Field name="name" class="form-control" :class="{ 'is-invalid': errors.name}"
                                              rules="required" v-model="customer.C_name" />
                                              <span class="clr3 ">{{ errors.name }} </span> -->
                                             
                                              
                                          </CCol>
                                          
                                      </div><br>
                                      <div class="row">
                  
                  
                                          <CCol md="3">
                                              <CFormLabel for="inputName4">Driving Licence No</CFormLabel>
                                              <CFormInput v-model="customer.driving_license" type="number" id="inputName4"  />
                                            
                                          </CCol>
                                          <CCol md="3">
                                              <CFormLabel for="inputName4">District</CFormLabel>
                                              <CFormInput v-model="customer.district" type="text" id="inputName4"  />
                                             
                  
                                          </CCol>
                                      </div><br>
                  
                                      <div class="row">
                                          <table class="table font1">
                                           <thead>
                                                  <tr>
                                                  <td class="" >  </td>
                                                    <td class="width2" >Address Line 1</td>
                                                    <td class="width2" >Address Line 2</td>
                                                    <td class="width2">Address Line 3</td>
                                                    <td class="width2" >Address Line 4</td>
                                                   
                                                  </tr>
                                                </thead> 
                                          <tbody class="">
                                              <tr>
                                                  <td class="">
                                                      <div class="form-check">
                                                          <input class="form-check-input" v-model="address[0].address_type"  name="address0" type="radio" value="Shipping address" id="flexCheckDefault">
                                                          <label class="form-check-label " for="flexCheckDefault">
                                                            Shipping address
                                                          </label>
                                                        </div>
                                                        <div class="form-check">
                                                          <input class="form-check-input" v-model="address[0].address_type"  name="address0" type="radio" value="Billing address" id="flexCheckChecked" >
                                                          <label class="form-check-label" for="flexCheckChecked">
                                                            Billing address
                                                          </label>
                                                        </div>
                                                  </td>
                                                  <td>   
                                                      <Field class="form-control" v-model="address[0].address_line_1" name="address1"
                                                      />
                                                    
                                                      
                          
                                                  </td>
                                                  <td>
                                                      <CFormInput type="text"  v-model="address[0].address_line_2" id="inputName4" />
                                                      
                                                  </td>
                                                  <td>
                                                      <CFormInput   type="text"  v-model="address[0].address_line_3"  id="inputName4" />
                                                     
                                                  </td>
                                                  <td>
                                                      <CFormInput type="text"  v-model="address[0].address_line_4" id="inputName4" />
                                                      
                                                  </td>
                                                  <td>
                                                      <!-- <button v-on:click="isHidden1 = !isHidden1" v-if="!isHidden1"  type="button"  @click="add1"  class="btn btn-primary button2">+</button>
                                                      <button  type="button" v-if="isHidden1" v-on:click="isHidden1 = !isHidden1" @click="remove1"  class="btn btn-primary button2">-</button>
                                                   -->
                                                   <span    type="button"  @click="add1"  class="me-2 mt-2"><i class="fa fa-plus" aria-hidden="true"></i></span>
                                                    
                                                  </td>
                                              </tr>
                                              <tr v-for="key1 in count1" :key="key1" >
                  
                                                  <td >
                                                      <!-- <CFormInput v-model="values['address1-'+key]" type="text" />  -->
                                                      <div class="form-check">
                                                          <input class="form-check-input"  v-model="address[key1].address_type"  type="radio" value="Shipping address" id="flexCheckDefault">
                                                          <label class="form-check-label" for="flexCheckDefault">
                                                            Shipping address
                                                          </label>
                                                        </div>
                                                        <div class="form-check">
                                                          <input class="form-check-input"   v-model="address[key1].address_type"  type="radio" value="Billing address" id="flexCheckChecked" >
                                                          <label class="form-check-label" for="flexCheckChecked">
                                                            Billing address
                                                          </label>
                                                        </div>
                                                </td>
                    
                                                  <td>
                                                     <CFormInput   v-model="address[key1].address_line_1" type="text" /> 
                                                     
                                                </td>
                    
                                                  <td>
                                                      <CFormInput   v-model="address[key1].address_line_2" type="text" /> 
                                                     
                                                  </td>
                    
                                                  <td>
                                                      <CFormInput   v-model="address[key1].address_line_3" type="text" /> 
                                                     
                                                  </td>
                                                  <td>
                                                      <CFormInput   v-model="address[key1].address_line_4" type="text" />
                                                      
                                                  </td>
                    
                                                  <td>
                                                   
                                                    <span type="button"  @click="remove1"  class="mt-2"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                                </td>
                    
                                                </tr>
                  
                                          </tbody>
                                          </table>
                                        
                                         
                                      </div><br>
                                      
                                      
                                      <p class="clr2"><b>Add Contact Details</b> </p>
                                
                                      <table class="table">
                                          <thead>
                                              <tr>
                                                <td class="width1" >Contact Name</td>
                                                <td class="width1" >Designation</td>
                                                <td class="width1">Email</td>
                                                <td class="width1" >Mobile No</td>
                                                <td class="" >  </td>
                                              </tr>
                                            </thead>
                                      <tbody   >
                                          <!-- {{index}}v-for="(customers, index) in customer" :key="customers.id" -->
                                              <tr  >
                  
                                                <th >
                                                  
                                                  <Field v-model="contact[0].name"   class="form-control" 
                                                  name="contactname" />
                                                
                                                 
                                              </th>
                  
                                                <td>
                                                   <CFormInput v-model="contact[0].designation" type="text" /> 
                                                 
                                              </td>
                  
                                                <td>
                                                  <Field v-model="contact[0].email"  name="contactemail" class="form-control" 
                                              rules="email"  />
                                             
                                             
                                                </td>
                  
                                                <td>
                                                  <Field v-model="contact[0].tel"  name="contactmobile" class="form-control" 
                                                  type="number"  />
                                                  
                                                    
                                                </td>
                  
                                                <td>
                                                  <!-- <button v-on:click="isHidden = !isHidden" v-if="!isHidden"  type="button"  @click="add"  class="btn btn-primary button2">+</button>
                                                  <button  type="button" v-if="isHidden" v-on:click="isHidden = !isHidden" @click="remove"  class="btn btn-primary button2">-</button> -->
                                                  <span    type="button"  @click="add"  class="me-2 mt-2"><i class="fa fa-plus" aria-hidden="true"></i></span>
                                              </td>
                  
                                              </tr>
                  
                                              <tr v-for="key in count" :key="key" >
                  
                                                  <th >
                                                      <CFormInput v-model="contact[key].name" type="text" /> 
                                                     
                                                </th>
                    
                                                  <td>
                                                     <CFormInput v-model="contact[key].designation" type="text" /> 
                                                     
                                                </td>
                    
                                                  <td>
                                                      <CFormInput v-model="contact[key].email" type="text" />  
                                                      
                  
                                                  </td>
                    
                                                  <td>
                                                      <CFormInput v-model="contact[key].tel" type="number" /> 
                                                     
                                                  </td>
                    
                                                  <td>
                                                    <!-- <button    type="button"  @click="add"  class="btn btn-primary button2">+</button>
                                                    <button type="button"  @click="remove"  class="btn btn-primary button2">-</button> -->
                                                    <span type="button"  @click="remove"  class="mt-2"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                                  </td>
                    
                                                </tr>
                                      </tbody>
                                      </table>
                                      <br>
                                      <p class="clr2"><b>Add Bank Details</b> </p>
                  
                                      <div class="row ms-1 me-1">
                                          <table class="table">
                                              <thead>
                                                  <tr>
                                                    <td class="width1" >name</td>
                                                    <td class="width1" >Bank Name</td>
                                                    <td class="width1" >Branch Name</td>
                                                    <td class="width1">Account Number</td>
                                                     <td class="" >  </td>
                                                  </tr>
                                                </thead>
                                          <tbody   >
                  
                                              <tr>
                                              <td >
                                                <CFormInput v-model="bankdet[0].name"   type="text" id="inputName4" />
                                              </td>
                                              <td>
                                                  <CFormInput v-model="bankdet[0].bank_name"  type="text" id="inputName4" />
                                              </td>
                                              <td>
                                                  <CFormInput v-model="bankdet[0].branch"  type="text" id="inputName4" />
                                              </td>
                                              <td>
                                                  <CFormInput v-model="bankdet[0].acount_num"  type="number" id="inputName4" />
                                              </td>
                                              <td>
                                                  <span    type="button"  @click="add2"  class="me-2 mt-2"><i class="fa fa-plus" aria-hidden="true"></i></span>
                                              </td>
                  
                                              </tr>
                  
                                              <tr v-for="key2 in count2" :key="key2" >
                  
                                                <th >
                                                  <CFormInput v-model="bankdet[key2].name" type="text" /> 
                                                 
                                            </th>
                                                <th >
                                                      <CFormInput v-model="bankdet[key2].bank_name" type="text" /> 
                                                     
                                                </th>
                    
                                                  <td>
                                                     <CFormInput v-model="bankdet[key2].branch" type="text" /> 
                                                     
                                                </td>
                    
                                                  <td>
                                                      <CFormInput v-model="bankdet[key2].acount_num" type="number" />  
                                                      
                  
                                                  </td>
                    
                                                  
                    
                                                  <td>
                                                    <!-- <button    type="button"  @click="add"  class="btn btn-primary button2">+</button>
                                                    <button type="button"  @click="remove"  class="btn btn-primary button2">-</button> -->
                                                    <span type="button"  @click="remove2"  class="mt-2"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                                  </td>
                    
                                                </tr>
                  
                                          </tbody>
                                          </table>
                  
                                          
                                      </div>
                                      <br>
                  
                                      <p class="clr2"><b>Add other Details</b> </p>
                  
                                      <div class="row">
                  
                                          <!-- <CCol md="3">
                                              <div class="group ">      
                                                  <input class="input3" type="text"  required >
                                                  <span class="highlight"></span>
                                                  <span class="bar"></span>
                                                  <label class="label1 font1">Bank Name</label>
                                              </div>
                                          </CCol>
                                          <CCol md="3">
                                              <div class="group ">      
                                                  <input class="input3" type="text"  required >
                                                  <span class="highlight"></span>
                                                  <span class="bar"></span>
                                                  <label class="label1 font1">Branch Name</label>
                                              </div>
                                          </CCol>
                                          <CCol md="3">
                                              <div class="group ">      
                                                  <input class="input3" type="text"  required >
                                                  <span class="highlight"></span>
                                                  <span class="bar"></span>
                                                  <label class="label1 font1">Account Number</label>
                                              </div>
                                          </CCol>-->
                                      </div> 
                  
                                      
                                      
                                      <CCol class="right1 mt-4">
                                         
                                      
                                         
                                      </CCol>
                                    </div>



                                    

                                    
                                 
                                    
                                  
                                      
                                      
                                  
                                  </div>
                                  <div class="modal-footer">
                                    <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                                    <button type="button" v-on:click="customerCreate()" class="btn btn-primary">Create</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            
                        </CCol>
                        <CCol md="3">
                            <CFormLabel  for="inputState">Type</CFormLabel> 
                           
                             <!-- <Field rules="required" id="inputState" name="group"  /> -->
                             <CFormSelect class=" "  name="name3" id="notificationPreference"  v-model="istockissue.SI_type"   rules="required" >
                                 
                                 <option class="font1">Rental VIN</option>
                                
                            
                                 
                             </CFormSelect>
                             <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                             <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                             </div> -->
                         </CCol>
                    </div><br>
                    <div class="row ">
                      <CCol md="3">
                        <CFormLabel  for="inputState">Sales Person</CFormLabel> 
                       
                         <!-- <Field rules="required" id="inputState" name="group"  /> -->
                        
                        
                        <select class="form-control"  name="ales_person" id="notificationPreference" v-model="istockissue.SI_sales_person"  >
                          <!-- <v-select class="widthmy"  :options="['Canada', 'United States','amila']" ></v-select>    -->
                          <option class="font1" value="0"></option>
                           
                            
                          <option v-for="salesperson in salespersons" :key="salesperson" :value="salesperson.id" class="font1">{{salesperson.name}}</option> 
                             
                         </select>
                        
                         <!-- <span class="clr3 ">{{ errors.group }} </span> -->
                         <!-- <div class="clr3"  v-show="!customer.group"  rules="required"  >This field is required
                         </div> -->
                     </CCol>
                        <CCol md="3">
                            <CFormLabel    for="inputName4">Security Deposit Amount</CFormLabel>
                             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                            

                             <Field name="Registration" v-model="istockissue.security_deposit_amount" type="number"  class="form-control" :class="{ 'is-invalid': errors.security_deposit_amount}"
                             rules="required"  />
                            
                            
                            
                            
                        </CCol>
                        <CCol md="3">
                            <CFormLabel for="inputName4">Purpose of Rent</CFormLabel>
                             <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                            

                             <textarea class="form-control" v-model="istockissue.purpose_of_rent" rows="3"></textarea>  
                         
                            
                            
                            
                        </CCol>
                      
                    </div><br>
                   
                    

                    <div class="row">
                      <CCol md="3">
                        <CFormLabel for="inputName4">Remarks</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <textarea v-model="istockissue.remarks"  class="form-control"  rows="3"></textarea>                                                  
                    </CCol>
                    </div><br>
                    <p class="clr2"><b>Issue Vehicle</b> </p>
                    <div class="row ms-1 me-1">
                        <table class="table">
                            <thead>
                                <tr>
                                  <td class="width8" >Reg No.</td>
                                  <td class="" >Start Date</td>
                                  <td class="" >Start Time</td>
                                  <td class="">Return Date</td>
                                  <td class="">Return Time</td>
                                  <td class="">Fuel Taken</td>
                                  <td class="">Start Mileage</td>
                                  <td class="">Rate Type</td>
                                  <td class="">Amount</td>
                                   <td class="" >  </td>
                                </tr>
                              </thead>
                        <tbody   >

                            <tr>
                            <td >
                              
                            <select class="form-control "  name="reg_no" id="notificationPreference" v-model="details[0].reg_no"   rules="required" >
                                 
                            <option class="font1"></option>
                               
                           <option v-for="miinventory in miinventorys" :key="miinventory" :value="miinventory.reg_no"  class="font1">{{miinventory.reg_no}} - {{miinventory.brand_name}} - {{miinventory.modelname}}</option>
                                
                            </select>
                            </td>
                            <td>
                                <CFormInput v-model="details[0].propose_start_date"  type="date" id="inputName4" />
                            </td>
                            <td>
                                <CFormInput v-model="details[0].propose_start_time"  type="time" id="inputName4" />
                            </td>
                            <td>
                                <CFormInput v-model="details[0].propose_return_date"  type="date" id="inputName4" />
                            </td>
                            <td >
                                <CFormInput v-model="details[0].propose_return_time"   type="time" id="inputName4" />
                              </td>
                              <td >
                               
                                <CFormSelect class=" "  name="fuel_taken" id="notificationPreference" v-model="details[0].fuel_taken"   rules="required" >
                                 
                                  <option class="font1">Select Fuel Taken</option>
                                     
                                 <option  class="font1">Full</option>
                                 <option  class="font1">Not Full</option>
                                      
                                  </CFormSelect>
                              </td>
                              <td >
                                <CFormInput v-model="details[0].start_mileage"   type="text" id="inputName4" />
                              </td>
                              <td >
                                <CFormInput v-model="details[0].ratetype"   type="text" id="inputName4" />
                              </td>
                              <td >
                                <CFormInput v-model="details[0].charge_amount"   type="number" id="inputName4" />
                              </td>
                            <td>
                                <span    type="button"  @click="add5"  class="me-2 mt-2"><i class="fa fa-plus" aria-hidden="true"></i></span>
                            </td>

                            </tr>

                            <tr v-for="key5 in count5" :key="key5" >

                              <th >
                               
                                <select class="form-control "   id="notificationPreference" v-model="details[key5].reg_no"   rules="required" >
                                 
                                  <option class="font1"></option>
                                     
                                 <option v-for="miinventory in miinventorys" :key="miinventory"  class="font1">{{miinventory.reg_no}} - {{miinventory.brand_name}} - {{miinventory.modelname}}</option>
                                      
                                  </select>
                               
                          </th>
                              <th >
                                    <CFormInput v-model="details[key5].propose_start_date" type="date" /> 
                                   
                              </th>
  
                                <td>
                                   <CFormInput v-model="details[key5].propose_start_time" type="time" /> 
                                   
                              </td>
  
                                <td>
                                    <CFormInput v-model="details[key5].propose_return_date" type="date" />  
                                    

                                </td>
                                <td>
                                    <CFormInput v-model="details[key5].propose_return_time" type="time" />  
                                    

                                </td>
                                <td>
                                    
                                    <CFormSelect class=" "  name="fuel_taken" id="notificationPreference" v-model="details[key5].fuel_taken"   rules="required" >
                                 
                                      <option class="font1">Select Fuel Taken</option>
                                         
                                     <option  class="font1">Full</option>
                                     <option  class="font1">Not Full</option>
                                          
                                      </CFormSelect> 
                                    

                                </td>
                                <td>
                                    <CFormInput v-model="details[key5].start_mileage" type="number" />  
                                    

                                </td>
                                <td>
                                    <CFormInput v-model="details[key5].ratetype" type="number" />  
                                    

                                </td>
                                <td>
                                    <CFormInput v-model="details[key5].charge_amount" type="number" />  
                                    

                                </td>
  
                                
  
                                <td>
                                  <!-- <button    type="button"  @click="add"  class="btn btn-primary button2">+</button>
                                  <button type="button"  @click="remove"  class="btn btn-primary button2">-</button> -->
                                  <span type="button"  @click="remove5"  class="mt-2"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                </td>
  
                              </tr>

                        </tbody>
                        </table>

                        
                    </div>

                    
                    
                    
                  
               
                   
                    

                   
                    
       
                    
                    
                    <CCol class="right1 mt-4">
                       
                    
                        <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
                        
                            <CButton  color="success" class="btn1" type="submit"> Create</CButton>
                            <router-link class="line1 btn btn-danger " to="/mrentedvehicles/index">Cancel</router-link>
                        </div>
                    </CCol>
                </Form>




            </div>
        </div>


        
         
           


    </div>
    <!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
    <!-- <form @submit.prevent="del()" class="" >
     <input type="text" v-model="user.id"  class="form-control" >
     <button  type="" class="btn btn-success" >delete</button>
     </form> -->

</template>

<script  type="text/javascript">
  
    import {  CCol, CFormLabel, CFormSelect,CFormInput,  CButton, } from '@coreui/vue';
    import { defineRule,Form, Field  } from 'vee-validate';
    //import httpClient from '@/axios';
    import NavView from '../../components/NavView.vue'
    import SideBar from '../../components/SideBar.vue'
    import authService from '@/auth.service';
    import axios from 'axios';
    //  import vSelect from 'vue-select';
     import "vue-select/dist/vue-select.css";
    

     
 
    
   
    defineRule('minMax', (value, [min, max]) => {
  // The field is empty so it should pass
  if (!value || !value.length) {
    return true;
  }
  const numericValue = Number(value.length);
  if (numericValue < min) {
    return 'Please enter a valid phone number.';
  }
  if (numericValue > max) {
    return 'Please enter a valid phone number.';
  }
  return true;
});

    defineRule('required', value => {
     if (!value || !value.length) {
    return 'This field is required';
    }
    return true;
    });

    defineRule('email', value => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true;
  }
  // Check if email
  if  (!/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/.test(value)) {
    
    return 'Please enter valid email address';
    
  }
  return true;
});



    

    export default {
      created(){


    
  this.load()
  
    },
        data() {
      
  
        
    
            return {
              // theme: null,
              // themes: [
              //       // Add Optgroup option (Dark Themes)
              //       { header: "Dark Themes" },
              //       { name: "Night Bright", themeFile: "night-bright.css" },
              //       { name: "Dracula", themeFile: "dracula.css" },
              //       // Add Optgroup option (Light Themes)
              //       { header: "Light Themes" },
              //       { name: "Day Bright", themeFile: "day-bright.css" },
              //       { name: "Blue", themeFile: "blue.css" }
              //   ],
                access_token:authService.isLoggedIn(),

                isHidden: false,
                count: 0,
                values:{},

                isHidden1: false,
                count1: 0,
                values1:{},

                isHidden2: false,
                count2: 0,
                values2:{},
                 
                count5: 0,
                values5:{},
               
                mvehicles:'',
                salespersons:'',
             
                miinventorys:'',
              mcustomers:[
               

              ] ,
                
             
              
          
            'istockissue':{
                'issues_date':'',
                'SI_created_date':'12-12-2021',
                'SI_created_by':'1',
                'SI_status':'1',
                'id_customer':'',
                'reference_invoice':'1',
                'id_customer_del_add':'1',
                'SI_type':'',
                'end_user':'test_user',
                'SI_sales_person':'1',
                'end_user_address':'test',
                'confirm_signature':'test',
                'security_deposit_amount':'',
                'purpose_of_rent':'',
                'remarks':'',


            },
            'details':[
                {},
            ],

              

            'customer': {
                    'C_code':'H-228922-000000561',
                    'customer_type' : '',
                    'C_name': '',
                    'C_firstname':'',
                    'C_lastname':'',
                    'district':'',
                    'salesexecutive': '',
                    'nic_no': '',
                    'driving_license': '',
                    // 'C_contact_tel1':'01122369875',
                    'C_email':'',
                },
                address: [
              {},
             
                ] ,

                
                'contact':[
                  {},
                 
                ],

                'bankdet':[
                  {},
                ],
           
              

              
               
            };
        },

        // validation:{
        //     customer: {
        //         name:{
        //             required,
        //             minLength: minLength(2),

        //         }



        //     },


        // },


        components: {
            CCol,Field, CFormLabel, CFormInput,  CButton,Form,NavView,SideBar,CFormSelect
          },

        methods: {

          customerCreate() {
      // console.log("here we are",this.errorlist); check karaganimata awashya we
     // console.log(this.customer);
     
        axios.post('/web/api/mcustomer/create',
        {customer:this.customer,contact:this.contact,address:this.address,bankdet:this.bankdet},{
        headers:{
        'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
            
                //'customer':this.customer,
                
           
        }
      }).then(
      response => {
        console.log(response);
      }
      )
     
      
      
    //   await httpClient.post('web/index.php/mcustomer/send',this.customer).then(
    //     response => {
    //       console.log(response);
    //      this.item = response.data.success;
           //window.location.reload();
          
      //  }
       
       //)
        
   

    },


   

    async saveData() {
    // console.log("here we are",this.errorlist); check karaganimata awashya we
    console.log(this.access_token);
    console.log(this.istockissue);
    console.log('amila');
    console.log(this.details);
    try {
      const { data} = await  axios.post('/web/api/istockissue/create' ,{gin:this.istockissue,details:this.details},{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
    } catch (error) {
      console.log(error);
    }
  //   await httpClient.post('web/index.php/mcustomer/send',this.customer).then(
  //     response => {
  //       console.log(response);
  //      this.item = response.data.success;
        // window.location.reload();
        
    //  }
     
     //)
      
 

  },


          async load() {
    console.log(this.access_token);
   

    try {
      const { data} = await  axios.get('/web/api/mcustomer/gincustomerlist',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mcustomers = data.item_list;
      
    } catch (error) {
      console.log(error.response);
    }


    try {
      const { data} = await  axios.get('/web/api/msalespeople/ginsplist',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.salespersons = data.item_list;
      
    } catch (error) {
      console.log(error.response);
    }


    try {
      const { data} = await  axios.get('/web/api/iinventory/ginvehicleslist',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.miinventorys = data.item_list;
     
    } catch (error) {
      console.log(error.response);
    }

    console.log(this.access_token);
   

   

    
  },





    
    add5: function(){
            this.count5++;
            this.details.push({
              
            },)
            },
    remove5: function () {
            this.count5--;
            this.details.splice({
              
            },1)
            }, 

    add: function(){
            this.count++;
            this.contact.push({
              
            },)
            },
    remove: function () {
            this.count--;
            this.contact.splice({
              
            },1)
    },
    add1: function(){
            this.count1++;
            this.address.push({
              
            },)
            },
    remove1: function () {
            this.count1--;
            this.address.splice({
              
            },1)
            },

    add2: function(){
            this.count2++;
            this.bankdet.push({
              
            },)
            },
   remove2: function () {
            this.count2--;
            this.bankdet.splice({
              
            },1)
            },
    
            // add(){
            //     this.customer.push({
                    // 'contactname': '',
                    // 'contactdis': '',
                    // 'contactemail': '',
                    // 'contactmobile': '',
            //     })

            // },

//             createNewElement() {
//     // First create a DIV element.
// 	var txtNewInputBox1 = document.createElement('div');
// 	var txtNewInputBox2 = document.createElement('div');
// 	var txtNewInputBox3 = document.createElement('div');
// 	var txtNewInputBox4 = document.createElement('div');

//     // Then add the content (a new input box) of the element.
// 	txtNewInputBox1.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox2.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox3.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";
// 	txtNewInputBox4.innerHTML = "<br><input type='text' class='form-control' id='newInputBox'>";

//     // Finally put it where it is supposed to appear.
// 	document.getElementById("newElementId1").appendChild(txtNewInputBox1);
//     document.getElementById("newElementId2").appendChild(txtNewInputBox2);
//     document.getElementById("newElementId3").appendChild(txtNewInputBox3);
//     document.getElementById("newElementId4").appendChild(txtNewInputBox4);
// },

 





            // saveData() {
                

            //     console.log("ok");
            //     console.log(this.customer);

                




            // }
        }

    };


</script>

<style scoped>

  .width8{
    width: 15%;
  }
   .font1{
    font-size: 13px !important;
 
  }
  .font-bold1{
    font-weight: bold;
  }
   
    .clr1 {
        background-color: #D4E1E8;
        padding: 2px;
        padding-left: 20px;
    }

    .clr2 {
        background-color: #AED8F2;
        padding: 2px;
        border-radius: 3px
    }

    .right1 {
        text-align: right;
    }

    .btn1 {
        padding-left: 22px;
        padding-right: 22px;
    }
    .btn11 {
       margin-top: 28px;
       padding-left: 75px;
       padding-right: 75px ;
       
    }

    .clr3 {
        color: red;
    }

    .left1{
        text-align: left;
    }

    .width1{
        width: 25%;
    }
    .width2{
        width: 20%;
    }
    

    .hiden1 {
        display: none;
    }
    .button2{
        margin-left: 5px;
    }
    .manage-boder{
    border-bottom: 2px solid #E9E9E3;
    border-top: 2px solid #E9E9E3;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold !important;
    }
    .colr1{
        color:#A5A5A3;
        
    }
    .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }
  .body1{
    border-top: 1px solid black;
  }
  .group 			  { 
  position:relative; 
  margin-bottom:10px; 
  
  
}
.input3 				{
  font-size:14px;
  padding:10px 10px 3px 5px;
  display:block;
  width:90%;
  border:none;
  border-bottom:2px solid #999;
}
.input3:focus 		{ outline:none; }

/* LABEL ======================================= */
.label1 				 {
  color:#999; 
  font-size:13px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all; 
  -moz-transition:0.2s ease all; 
  -webkit-transition:0.2s ease all;
}

/* active state */
.input3:focus ~ .label1, .input3:valid ~ .label1 		{
  top:-10px;
  font-size:13px;
  color:#999;
}
</style>